import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["list", "copyrightYear"];
import React, { isValidElement } from 'react';
import { Container } from "./Container";
import { Copyright } from "./Copyright";
import { Item } from "./Item";
import { List } from "./List";
export var AppFooter = /*#__PURE__*/React.forwardRef(function AppFooter(_ref, ref) {
  var _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      copyrightYear = _ref.copyrightYear,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Container, Object.assign({
    ref: ref
  }, props), /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement(List, null, list.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Item, {
      key: /*#__PURE__*/isValidElement(item) && item.key ? item.key : i
    }, item);
  }))), copyrightYear && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Copyright, {
    translate: "no"
  }, "\xA9 ", copyrightYear, " Spotify AB")));
});
/**
* **AppFooter** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AppFooter) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-app-appfooter--default) | [Encore](https://encore.spotify.net/web/components/app-layout?format=figma-figma#appfooter) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=263:9) |
*
* AppFooter is the standard footer used across all Web applications.
*
* @example
* () => {
*  const defaultLinks = [
*    {
*      label: 'Legal',
*      href: `https://www.spotify.com/us/legal`,
*    },
*    {
*      label: 'Privacy',
*      href: `https://www.spotify.com/legal/privacy-policy/`,
*    },
*    {
*      label: 'Cookies',
*      href: `https://www.spotify.com/legal/privacy-policy/#s13`,
*    },
*  ];
*  const copyrightYear = new Date().getFullYear();
*
*  return (
*    <AppFooter
*      copyrightYear={copyrightYear}
*      list={defaultLinks.map(link => (
*        <AppFooterLink key={link.label} href={link.href} target="_blank">
*          {link.label}
*        </AppFooterLink>
*      ))}
*    />
*  );
*};
*
*/

export default AppFooter;